// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MIC_YEAR_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_YEAR_LOADED() {
      return {
        isLoading: false,
        data: action.micYear,
        year: action.year
      };
    },
    MIC_YEAR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYear.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
